// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__o9qyE","alertIcon":"ConfirmModal_alertIcon__32tR8"};